import * as React from 'react';
import { QuestionHeading } from '../../components/QuestionHeading';
import { useFormTitle } from '../../utils/hooks';
import { useApplicationContext } from '../ApplicationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionHeadingContainer = function QuestionHeadingContainer() {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var title = useFormTitle();

  // Для модалки компонент не рендерится, у модалки свой Header в который встраивается заголовок
  if (layoutConfiguration.type === 'modal') {
    return null;
  }
  return /*#__PURE__*/_jsx(QuestionHeading, {
    title: title
  });
};